import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CardLoader from '../../components/Loader/Loader';
import Logout from '../../components/Logout/Logout';
import LogoutSuccess from '../../components/LogoutSuccess/LogoutSuccess';
import useLogoutContext, { ELogoutUiState, LogoutProvider } from '../../contexts/LogoutContext';
import PageLayout from '../../layout/PageLayout/PageLayout';
import { ERoutes } from '../../util/constants';

const LogoutRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.logout}>
                <Logout />
            </Route>
            <Route path={ERoutes.logoutSuccess}>
                <LogoutSuccess />
            </Route>
        </Switch>
    );
};

const LogoutUi: FC = () => {
    const { logoutUiState, redirectUrl } = useLogoutContext();

    switch (logoutUiState) {
        case ELogoutUiState.default:
        case ELogoutUiState.queryStringParsed:
            return <CardLoader />;
        case ELogoutUiState.ready:
            return <LogoutRouter />;
        case ELogoutUiState.redirect:
            return (
                <>
                    <CardLoader />
                    {window.location.assign(redirectUrl)}
                </>
            );
        case ELogoutUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.logoutSuccess} />
                    <LogoutRouter />
                </>
            );
        case ELogoutUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            console.error('Invalid logout ui state');
            return <Redirect to={ERoutes.error} />;
    }
};

const LogoutScreen: FC = () => {
    return (
        <LogoutProvider>
            <PageLayout>
                <LogoutUi />
            </PageLayout>
        </LogoutProvider>
    );
};

export default LogoutScreen;
